import { useMemo } from 'react';

import {
  useCanAccessCommunicationsDashboard,
  useCanAccessCommunicationsDashboardConversationsPage,
} from '../../featureChecks';
import type { UseMainUIFeatureSettings } from '../../types';
import { uiFeatureAccessSymbol } from '../../types';

export const useCommsDashboardConversationsPageSettings: UseMainUIFeatureSettings<
  'communicationsDashboardFeaturedConversationsPage'
> = (options) => {
  const canAccessDashboard = useCanAccessCommunicationsDashboard();
  const canAccessConversations = useCanAccessCommunicationsDashboardConversationsPage();

  return useMemo(() => {
    const overrides = options?.overrides?.communicationsDashboardFeaturedConversationsPage ?? {};

    return {
      [uiFeatureAccessSymbol]: canAccessDashboard && canAccessConversations,
      ...overrides,
    };
  }, [options, canAccessDashboard, canAccessConversations]);
};
